import React from "react";
import "./SlotGamesDevelopmentCompanyStyle.scss";
import { slotGamesDevelopmentCompanyTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const SlotGamesDevelopmentCompanySection = () => {
  return (
    <section className="slot-games-development-company-section">
      <div className="slot-games-development-company-wrap">
        <SectionHeading>{slotGamesDevelopmentCompanyTextContent.headingText}</SectionHeading>

        <div className="slot-games-development-company-box">
          <div className="chips-box">
            {slotGamesDevelopmentCompanyTextContent.content.map((section, index) => (
              <div className="chip" key={index}>
                <span className="icon-box">
                {section.chipIconSrc}
                </span>
                <span className="chip-label-text">{section.chipLabelText}</span>
              </div>
            ))}
          </div>

          <div className="text-box">
            <p className="para-text">{slotGamesDevelopmentCompanyTextContent.paraText}</p>
          </div>

          <div className="img-box">
            <img src={slotGamesDevelopmentCompanyTextContent.imgSrc} alt="Image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesDevelopmentCompanySection;
